import { render, staticRenderFns } from "./revt_center.vue?vue&type=template&id=3f975656&scoped=true"
import script from "./revt_center.vue?vue&type=script&lang=js"
export * from "./revt_center.vue?vue&type=script&lang=js"
import style0 from "./revt_center.vue?vue&type=style&index=0&id=3f975656&prod&lang=css"
import style1 from "./revt_center.vue?vue&type=style&index=1&id=3f975656&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f975656",
  null
  
)

export default component.exports